export default {
    name: "SchemaMarkupCheckbox",

    props: {
        modelValue: { type: Boolean, default: false },
        label: { type: String, default: "" },
        disabled: { type: Boolean, default: false }
    },

    emits: ["update:modelValue"],

    setup(props, { emit }) {
        const onChange = (event) => emit("update:modelValue", event.target.checked)
        return { onChange }
    }
}
